/* global $ mymuesli */

/**
 * Override the following functions.
 * - $.hasClass(string | function) : jQuery
 * - $.addClass(string | function) : jQuery
 * - $.removeClass(string | function) : jQuery
 * The behavior will be changed so, that addClass('.test') will be threaded like addClass('test'). So we can use
 * class selectors instead of class names.
 */
(function ()
{

    var WHITESPACE = ' ';
    var PATTERN_WHITESPACE = /\s+/;
    var CLASS_INDICATOR = '.';

    var _originalAddClass = $.fn.addClass;
    var _originalRemoveClass = $.fn.removeClass;
    var _originalHasClass = $.fn.hasClass;

    /* Be aware of undefined and null class. Yes, actually this should not be possible... */
    var _killPoints = function (classSelector)
    {
        if (typeof classSelector === 'function')
        {
            classSelector = classSelector();
        }
        if (typeof classSelector !== 'string')
        {
            return classSelector;
        }
        var newClassSelector = [];
        $(classSelector.split(PATTERN_WHITESPACE)).each(function (index, classSelectorToken)
        {
            newClassSelector.push(classSelectorToken.substring((classSelectorToken.indexOf(CLASS_INDICATOR) === 0) ? 1 : 0));
        });
        return newClassSelector.join(WHITESPACE);
    };

    $.fn.hasClass = function (classSelector)
    {
        return _originalHasClass.apply(this, [_killPoints(classSelector)]);
    };

    $.fn.addClass = function (classSelector)
    {
        return _originalAddClass.apply(this, [_killPoints(classSelector)]);
    };

    $.fn.removeClass = function (classSelector)
    {
        return _originalRemoveClass.apply(this, [_killPoints(classSelector)]);
    };

}) ();

(function () {

    const ID_PREFIX = 'js-generated-id-';

    let id = 0;

    /**
     *
     */
    class AbstractComponent {

        /**
         *
         */
        constructor ($element) {
            this.$element = $element;
            if ($element.attr('id') === undefined) {
                $element.attr('id', ID_PREFIX + (id++));
            }
            $element.data('component', this);
        }

        /**
         *
         *
         * @param selector
         * @param clazz
         * @param args
         * @private
         */
        static _parse (selector, clazz) {

            $(selector).each(
                function (_, element) {
                    const $element = $(element);
                    new clazz($element); // Use TS Varargs here
                    $element.removeClass(selector);
                }
            );
        }

    }

    /* Expose the class. */
    mymuesli.interface.components = mymuesli.interface.components || {};
    mymuesli.interface.components.AbstractComponent = AbstractComponent;

}) ();
